import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-input',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
    <div [id]="field.key" [formGroup]="form"
        [class]="'form-group schema-form-input has-feedback' + (props['htmlClass'] || '')"
        [class.has-success]="(formControl.dirty || formControl.touched) && formControl.status === 'VALID'"
        [class.has-error]="(formControl.dirty || formControl.touched) && formControl.status === 'INVALID'">
            <label *ngIf="props['title']"
              [class]="'control-label ' + props['labelHtmlClass'] || ''"
              [innerHTML]="props.required !== true ? props['title'] + ' (Optional)' : props['title']">
            </label>
            <p *ngIf="props['supportingText']">{{props['supportingText']}}</p>
            <div class="has-feedback">
                <div *ngIf="props['fieldAddonLeft'] || props['fieldAddonRight']" [class.input-group]="props['fieldAddonLeft'] || props['fieldAddonRight']">
                    <span class="input-group-addon" *ngIf="props['fieldAddonLeft']">{{props['fieldAddonLeft']}}</span>
                    <input
                    [formControl]="formControl"
                    [formlyAttributes]="field"
                    [attr.required]="props.required"
                    [attr.aria-describedby]="'control' + field.key + 'Status'"
                    [attr.list]="'control' + field.key + 'Autocomplete'"
                    [class]="'form-control ' + props['fieldHtmlClass'] || ''"
                    [id]="'control' + field.key"
                    [name]="field.key"
                    [type]="props['numberType'] ? 'number' : field.type"
                    [minlength]="props.minlength"
                    [maxlength]="props.maxlength"
                    [attr.disabled]="props.disabled"
                    >
                    <span class="input-group-addon" *ngIf="props['fieldAddonRight']">{{props['fieldAddonRight']}}</span>
                </div>
                <input
                    *ngIf="!props['fieldAddonLeft'] && !props['fieldAddonRight']"
                    [formControl]="formControl"
                    [formlyAttributes]="field"
                    [attr.required]="props.required"
                    [attr.aria-describedby]="'control' + field.key + 'Status'"
                    [attr.list]="'control' + field.key + 'Autocomplete'"
                    [class]="'form-control ' + props['fieldHtmlClass'] || ''"
                    [id]="'control' + field.key"
                    [name]="field.key"
                    [type]="props['numberType'] ? 'number' : field.type"
                    [minlength]="props.minlength"
                    [maxlength]="props.maxlength"
                    [attr.disabled]="props.disabled"
                >
                <i *ngIf="(formControl.dirty || formControl.touched)" class="fa form-control-feedback" [class.fa-times-circle-o]="formControl.status === 'INVALID'" [class.fa-check-circle-o]="formControl.status === 'VALID'"></i>
            </div>
        <div class="help-block" *ngIf="(formControl.dirty || formControl.touched)">
            <formly-validation-message [field]="field"></formly-validation-message>
        </div>
    </div>
  `
})
export class InputFieldTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
    ngOnInit() {
        if (this.formControl.value) {
            this.formControl.markAsTouched();
        }
    }
}
